import styled, { css } from 'styled-components';
import { CalendarPopUpWrapper } from 'components/BKJDatePicker';

export const FilterBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  flex-wrap: wrap;
  border-top: 1px solid ${({ theme }) => theme.colors.Grey3};
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey3};
  background-color: ${({ theme }) => theme.colors.White};
`;

export const FilterSection = styled.div`
  min-width: 130px;
`;

export const DateFilterSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
`;

export const DatePresetButton = styled.button<{ isActive: boolean }>`
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.Grey4};
  background-color: ${({ theme }) => theme.colors.White};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s ease;

  ${({ isActive, theme }) =>
    isActive &&
    css`
      background-color: ${theme.colors.PrimaryDefault};
      color: ${theme.colors.White};
      border-color: ${theme.colors.PrimaryDefault};
    `}

  &:hover {
    background-color: ${({ isActive, theme }) =>
      isActive ? theme.colors.PrimaryDefault : theme.colors.Grey1};
  }
`;

export const ResetButton = styled.button`
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.Grey4};
  background-color: ${({ theme }) => theme.colors.White};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.colors.Grey1};
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.Grey5};
    border-color: ${({ theme }) => theme.colors.Grey3};
    cursor: not-allowed;
  }
`;

export const DateRangeTrigger = styled.button<{ $isOpen?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid
    ${({ theme, $isOpen }) => ($isOpen ? theme.colors.PrimaryDefault : theme.colors.Grey4)};
  background-color: ${({ theme }) => theme.colors.White};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;

  & svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.PrimaryDefault};
  }
`;

export const DateRangeSeparator = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.Grey6};
`;

export const PayPeriodFilterSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  flex-wrap: wrap;
`;

export const PayPeriodLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.Grey6};
  white-space: nowrap;
`;

export const PayPeriodCalendarWrapper = styled(CalendarPopUpWrapper)`
  height: auto;
`;
